import { useQuery, UseQueryResult } from "@tanstack/react-query";
import config from "../config.json";
import { createAxiosInstance } from "./ServicesHelpers";

export type GlobalConfigType = "REFERENCE_CURRENCY" | "DEFAULT_CURRENCY_PROVIDER";

/** @deprecated Use GlobalConfigType */
export type GlobalConfigKey = GlobalConfigType;

export interface IGlobalConfig {
  id: number;
  type: GlobalConfigType;
  value: string;
  createdBy?: string;
  updatedBy?: string;
  timestamp?: string;
  version?: number;
}

/** @deprecated Use IGlobalConfig */
export type ISystemConfig = IGlobalConfig;

const axiosInstance = createAxiosInstance(config.ADMIN_API_BASE_URL);

export const fetchGlobalConfigByType = async (
  type: GlobalConfigType
): Promise<IGlobalConfig | null> => {
  try {
    const response = await axiosInstance.get("/global-config", {
      params: { type },
    });
    const data = response.data;
    const items: IGlobalConfig[] = data?.content ?? (Array.isArray(data) ? data : [data]);
    return items.find((item) => item?.type === type) ?? null;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while fetching global config."
    );
  }
};

/** @deprecated Use fetchGlobalConfigByType */
export const fetchGlobalConfig = () => fetchGlobalConfigByType("REFERENCE_CURRENCY");

/** @deprecated Use fetchGlobalConfig */
export const fetchSystemConfig = fetchGlobalConfig;

export const fetchGlobalConfigById = async (
  id: number | string
): Promise<IGlobalConfig> => {
  try {
    const response = await axiosInstance.get(`/global-config/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while fetching global config."
    );
  }
};

/** @deprecated Use fetchGlobalConfigById */
export const fetchSystemConfigById = fetchGlobalConfigById;

export const createGlobalConfigApi = async (
  data: Partial<IGlobalConfig>
): Promise<IGlobalConfig> => {
  try {
    const response = await axiosInstance.post("/global-config", data);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while creating global config."
    );
  }
};

/** @deprecated Use createGlobalConfigApi */
export const createSystemConfigApi = createGlobalConfigApi;

export const editGlobalConfigApi = async (
  id: number | string,
  data: Partial<IGlobalConfig>
): Promise<IGlobalConfig> => {
  try {
    const response = await axiosInstance.put(`/global-config/${id}`, data);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while updating global config."
    );
  }
};

/** @deprecated Use editGlobalConfigApi */
export const editSystemConfigApi = editGlobalConfigApi;

export const useGlobalConfigByTypeQuery = (
  type: GlobalConfigType
): UseQueryResult<IGlobalConfig | null, Error> => {
  return useQuery({
    queryKey: ["globalConfig", type],
    queryFn: () => fetchGlobalConfigByType(type),
  });
};

/** @deprecated Use useGlobalConfigByTypeQuery */
export const useGlobalConfigQuery = () =>
  useGlobalConfigByTypeQuery("REFERENCE_CURRENCY");

/** @deprecated Use useGlobalConfigQuery */
export const useSystemConfigQuery = useGlobalConfigQuery;
